import { render, staticRenderFns } from "./SectionButton.vue?vue&type=template&id=aaad8fba&scoped=true&"
import script from "./SectionButton.vue?vue&type=script&lang=js&"
export * from "./SectionButton.vue?vue&type=script&lang=js&"
import style0 from "./SectionButton.vue?vue&type=style&index=0&id=aaad8fba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaad8fba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
